import { useState } from 'react'
import styled from 'styled-components'
import RecommendationDetails from './RecommendationDetails/RecommendationDetails'
import RecommendationModal from '../../RecommendationModal/RecommendationModal'
import Button from '../../Button/Button'

const Container = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 30px;
  background-color: var(--color-bg-sidebar);
  width: 570px;
  border-radius: 4px;
  box-shadow: 0 4px 11px 0 rgba(0, 0, 0, 0.2);
  position: relative;

  &:not(:last-child) {
    margin-bottom: 20px;
  }

  svg {
    height: 25px;
    fill: white;
  }

  @media only screen and (max-width: 600px) {
    width: 100%;
  }
`

const Title = styled.h1`
  display: -webkit-box;
  flex: 1;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-weight: bold;
  font-size: 16px;
  line-height: 1.1;
  color: var(--color-primary);
  padding-right: 20px;
  margin-bottom: 8px;
`

const IconWrapper = styled.div`
  position: absolute;
  top: -12px;
  right: -12px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background-color: #4a4a4a;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
`

const Description = styled.p`
  margin-top: 9px;
  width: 100%;
  color: var(--color-text-secondary);
  font-size: 16px;
  line-height: 1.2;

  @media only screen and (max-width: 600px) {
    margin-bottom: 18px;
  }
`

const HighPriorityBadge = styled.span`
  font-size: 10px;
  font-weight: 900;
  background-color: rgba(255, 0, 0, 0.2);
  color: red;
  padding: 3px 10px;
  border-radius: 12px;
  text-transform: uppercase;
  margin-bottom: 8px;
  align-self: flex-start;
`

const Col = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const Row = styled.div`
  display: flex;
  align-items: center;
`

const TopRecommendation = ({
  id,
  title,
  shortDescription,
  description,
  Icon,
  highPriority,
  status,
  awsPillar,
  estimation,
  activeCard,
  setActiveCard,
}) => {
  const [isOpen, setOpen] = useState(false)
  const toggle = () => setOpen(open => !open)

  if (activeCard === id)
    return (
      <RecommendationDetails
        id={id}
        title={title}
        shortDescription={shortDescription}
        description={description}
        awsPillar={awsPillar}
        estimation={estimation}
        Icon={Icon}
        setActiveCard={setActiveCard}
      />
    )

  return (
    <>
      <Container onClick={() => toggle()} className='top-recommendation'>
        <IconWrapper>
          <Icon />
        </IconWrapper>
        <Col>
          {highPriority && <HighPriorityBadge>High Priority</HighPriorityBadge>}
          <Row style={{ alignItems: "unset" }} >
            <Title title={title}>{title}</Title>
          </Row>
          <Row style={{ justifyContent: 'space-between' }}>
            <Description dangerouslySetInnerHTML={{ __html: shortDescription || description }} />
          </Row>
        </Col>
        <Button
          className='top-rec-plan-btn'
          onClick={e => {
            e.stopPropagation()
            setActiveCard(id)
          }}
          letterSpacing='2px'
          fontSize='10px'
          style={{ marginTop: '28px' }}
        >
          Plan This
        </Button>
      </Container>
      {isOpen && (
        <RecommendationModal
          isOpen={isOpen}
          toggle={toggle}
          id={id}
          title={title}
          estimation={estimation}
          shortDescription={shortDescription}
          description={description}
          awsPillar={awsPillar}
          recStatus={status}
          Icon={Icon}
        />
      )}
    </>
  )
}

export default TopRecommendation
